<template>
	<div>
		<el-form
				ref="form"
				:model="info"
				status-icon
				label-position="left"
				label-width="5rem"
				size="mini"
				v-loading="loadings.main"
				@submit.native.prevent
				class="row"
				:rules="rules"
				v-if="hasGetTableDataModel"
		>
			<div :class="'col-md-'+(key.col?key.col:3)" v-for="(key,index) in fields" :key="index">
				<el-form-item :label="dataModels['Reserve_transaction'][key.name].show_name" :prop="key.name">
					<field-editor
							v-model="info[key.name]"
							:field-info="dataModels['Reserve_transaction'][key.name]"
							:params="key.params"
							:width="key.width"
					></field-editor>
				</el-form-item>
			</div>
			<div class="col-md-12">
				<div class="dl total-show">
					<span class="dt">总数量</span>
					<span class="dd">{{total_amount}}</span>
					<template>
						<span class="dt">总价格</span>
						<span class="dd">{{total_price}}</span>
					</template>
				</div>
			</div>
		</el-form>
		<tx-items v-if="canEditItems" v-model="info.items" :isNeedCost="true"></tx-items>
		<warehouse-items
				class="mt-3"
				@insert="onInsertItems($event)"
				v-if="canEditItems"
				:filter="filterItems"
		></warehouse-items>
		<hr />
		<div class="btn-holder text-center" v-loading="loadings.main">
			<el-button size type="success" :disabled="info.items.length==0" @click="handlerPostType()">保存</el-button>
			<el-button
					size
					type="primary"
					:disabled="info.items.length==0"
					v-if="info.status.index==11"
					@click="handlerPost('edit_verify')"
			>审核</el-button>
		</div>
	</div>
</template>

<script>
import ReserveInventory from "@/mixinsApp/ReserveInventory";
import TxOp from "@/mixinsApp/TxOp.js";
import WarehouseItems from "@/widgets/WarehouseItems.vue";

export default {
	components: {WarehouseItems},
	mixins: [ReserveInventory, TxOp],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
			},

			info: {
				_id: "",
				storehouse: {
					name: "",
					_id: "",
				},
				show_id: "",
				items: [],
				discount: 0,
				status: {
					index: 0,
				},
			},
		};
	},
	props: {
		recordId: {
			type: String,
			default: "",
		},
		value: {
			type: Object,
			default: null,
		},
		type: {
			type: String,
			default: "inbound",
		},
	},
	computed: {
		canEditItems() {
			if (!this.hasGetTableDataModel) {
				return false;
			}
			if (this.info.storehouse._id) {
				return true;
			}
			return false;
		},
		fields() {
				return [
					{
						name:"storehouse",
						params: {
							allowCreate: false,
						},
						col: 3,
					},
				];
		},
		filterItems() {
			// if (this.type == "pre") {
			// 	return {
			// 		amount: { k: "amount", t: "int", lge: "==", v: 0 },
			// 	};
			// }
			return {};
		},
	},
	methods: {
		handlerPostType() {
				this.handlerPost("edit_inbound");
		},
		doResetAll() {
			this.info = {
				_id: "",
				storehouse: {
					name: "",
					_id: "",
				},
				show_id: "",
				items: [],
				discount: 0,
				status: {
					index: 0,
				},
			};
		},
		_doPost(type) {
			this.loadings.main = true;
			let post_info = JSON.parse(JSON.stringify(this.info));
			post_info.items = post_info.items.map(val => {
				return {
					_id: val._id,
					amount: val.amount,
					price_per: val.price_per,
					item: {
						_id:val.item._id
					},
					total_price: val.total_price,
					product_color: {
						_id:val.product_color._id
					},
					warehouse:val.warehouse
				};
			});
			console.log("post_info", post_info);
			this.$axios
					.post(`/reserve/inbound`, post_info)
					.then(json => {
						this.loadings.main = false;

						this.$message.success("成功");
						this.doResetAll();
					})
					.catch(json => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
		},
	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					this.info = Object.assign({}, val);
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
